// Menus keep one highlighted row. Keyboard focus and pointer hover share the
// same fill (DESIGN.md "State rules": menu item focus is the hover highlight),
// so when the pointer moves onto a row it takes focus too; otherwise the row
// the arrow keys left behind and the row under the pointer would both light up.

const DEFAULT_ROWS = '[role^="menuitem"]';

/**
 * Returns an onMouseMove handler for a menu panel.
 * @param {string} [selector] rows that can take focus
 */
export const focusRowUnderPointer =
  (selector = DEFAULT_ROWS) =>
  (event) => {
    const row =
      event.target instanceof Element ? event.target.closest(selector) : null;
    if (!row || row.disabled || row.getAttribute("aria-disabled") === "true")
      return;
    if (row === document.activeElement || !event.currentTarget.contains(row))
      return;
    row.focus({ preventScroll: true });
  };
